import { useState } from 'react';

export const WaterButNoCoffee = ({ ratio }) => {
  const [water, setWater] = useState('');

  const waterAmount = () => {
    const parse = water.replace(',', '.');
    const amount = parseFloat(parse, 10) / ratio;
    if (isNaN(amount)) {
      return 0;
    }

    if (amount === Infinity) {
      return 0;
    }

    return amount.toFixed(2);
  };

  return (
    <section>
      <h2>Jeg har vann, men ikke kaffe!</h2>
      <div>
        Jeg har
        <input
          placeholder="0"
          className="number"
          type="text"
          inputMode="decimal"
          pattern="[0-9]*"
          value={water}
          min={125}
          onChange={e => {
            setWater(e.target.value);
          }}
        />
        <span className="number">ml</span> vann, så jeg trenger{' '}
        <span className="number">{waterAmount()}g</span> kaffe!
      </div>
    </section>
  );
};
/*
1:12
1:13
1:15
*/
